import React, { Component } from 'react'
import { PropTypes } from 'prop-types'
import { updateComponent } from '../../state/actions/componentsActions'
import { open as openChatbot } from '../../state/actions/chatbotActions'
import { connect } from 'react-redux'
import Link from '../link'
import { request } from '../../state/api'

import { css, withStyles } from '../../styles/withStyles'
import Styles from './styles'

class LabelWithLink extends Component {
  constructor(props) {
    super(props)
  }

  componentWillReceiveProps(nextProps) {
    const { dispatch, component, components } = nextProps
    if (
      !!component &&
      !!component.link &&
      component.link.hasOwnProperty('fired') &&
      !component.link.fired &&
      component.link.method === 'POST'
    ) {
      this.sendOtp(dispatch, component, components)
    }
  }

  sendOtp(dispatch, component, components) {
    const body = component.link.mapping.reduce(
      (res, m) => ({ ...res, [m.key]: components[m.componentId].value }),
      {}
    )

    if (!!Object.keys(body).reduce((res, k) => res && !!body[k], true)) {
      dispatch(
        updateComponent(component.id, {
          link: {
            ...component.link,
            fired: true
          }
        })
      )
      request({
        endpoint: component.link.url,
        method: component.method,
        body /*, apiRoot*/
      }).then(json => {
        dispatch(
          updateComponent(component.link.requestIdComponentId, {
            value: json.requestId
          })
        )
      })
    }
  }
  onChange() {
    const { component, dispatch } = this.props

    if (!this.input.disabled) {
      if (component.status.indexOf('checkonly') > -1) {
        if (component.value !== 'selected') {
          dispatch(
            updateComponent(component.id, {
              value: 'selected'
            })
          )
          if (!!component.action)
          {
          dispatch(updateComponent(component.id, component.action))
          }
        }
      } else {
        dispatch(
          updateComponent(component.id, {
            value: this.input.checked ? 'selected' : ''
          })
        )
      }
    }
}
  handleOpenChatbot(e) {
    e.preventDefault()
    const { dispatch } = this.props
    dispatch(openChatbot())
  }

  handleSendOtpClick(e) {
    e.preventDefault()
    const { dispatch, component, components } = this.props
    this.sendOtp(dispatch, component, components)
  }

  render() {
    const { component } = this.props
    const chunks =component.id==="SZ0023-SS0048_DM0089_RI1056" || component.id==="PRIVACY-PRIVACY" ?component.description.split(/\s(?=\s§\w*§)|(§\w*§)/g): component.value.split(/\s(?=\s§\w*§)|(§\w*§)/g)

    let conditionalProps
    if (component.link && component.link.method !== 'POST') {
      conditionalProps = {
        href: component.link.url,
        target: component.link.target
      }
    } else {
      conditionalProps = {
        href: '#',
        onClick: this.handleSendOtpClick.bind(this)
      }
    }

    if (component.id === 'TERMINA_PROCEDURA-RESIDENZA_ITA') {
      conditionalProps.onClick = this.handleOpenChatbot.bind(this)
    }
    const Element = component.element ? component.element : (component.id==="SZ0023-SS0048_DM0089_RI1056")?'span':'p'
   
    return (
      <Element
        {...css(
          this.props.styles.component && this.props.component.id!=="SZ0023-SS0048_DM0089_RI1056",
          this.props.styles['component--block'],
          this.props.styles.label
        )}
      >
        {chunks.map((chunk, index) => {
          if (component.link) {
            return chunk === component.link.placeholder ? (
              <Link key={index} {...conditionalProps}>
                {component.link.text}
              </Link>
            ) : (
              chunk
            )
          }
          if (component.links) {
            const link = component.links.find(l => l.placeholder === chunk)

            if (!!link) {
              return (
                <Link
                  key={index}
                  href={link.url}
                  target={link.target}
                  {...conditionalProps}
                >
                  {link.text}
                </Link>
              )
            } else {
              return chunk
            }
          }
        })}
        {component.additionalView && component.additionalView(this.props)}
      </Element>
    )
  }
}

LabelWithLink.propTypes = {
  widget: PropTypes.object.isRequired,
  component: PropTypes.object.isRequired,
  styles: PropTypes.object.isRequired
}

const mapStateToProps = (state, ownProps) => {
  const { components } = state
  return { component: components[ownProps.component.id], components }
}

export default connect(mapStateToProps)(withStyles(Styles)(LabelWithLink))



// WEBPACK FOOTER //
// ./components/labelWithLink/index.js